module.exports = __webpack_public_path__ + "static/stjo-3-97c5c0c310342e58aded34cb6f6361b2.jpg";